<template>
  <validation-provider
    v-slot="{ valid, errors, untouched }"
    ref="validator"
    :vid="inputId"
    :name="$attrs.name"
    :rules="rules"
  >
    <b-form-group
      :id="inputId + '-group'"
      :label="label"
      :label-for="inputId"
    >
      <b-form-file
        :id="inputId"
        ref="file"
        v-model="inputValue"
        :name="$attrs.name || label"
        :state="untouched || (errors[0] ? false : (valid ? true : null))"
        :placeholder="'choose_files_placeholder' | i18n"
        :drop-placeholder="'drop_files_placeholder' | i18n"
        :browse-text="'browse' | i18n"
        :accept="fileExtensions"
        :disabled="disabled"
        :file-name-formatter="formatNames"
        multiple
        size="sm"
      />
      <b-form-invalid-feedback id="inputLiveFeedback">
        {{ errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
import {ValidationProvider} from 'vee-validate';
import {BFormFile} from 'bootstrap-vue';

export default {
  name: 'ValidatedMultifileInput',
  components: {ValidationProvider, BFormFile},
  props: {
    inputId: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    fileExtensions: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    inputValue: null
  }),
  watch: {
    inputValue(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.inputValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.inputValue = this.value;
    }
  },
  methods: {
    formatNames(files) {
      if (files.length < 5) {
        return files.map(f => f.name).join(', ');
      } else {
        return this.$translate('number_of_files_selected', {numberOfFiles: files.length});
      }
    }
  }
};
</script>

<style scoped>

</style>
